// @flow
import { getToken } from 'services/Authentication';
import { EnvApiUrls } from 'UI/constants/defaults';
import { FormSchema } from 'UI/constants/entityTypes';

import useFetchCandidateDataSheet from './useFetchCandidateDataSheetSchema';

const useCandidateDataSheetSchema = () => {
  const [state, actions] = useFetchCandidateDataSheet({
    schemaName: FormSchema.CandidateDataSheetFull
  });

  return [
    {
      ...state,
      httpOptions: {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          'x-api-key': EnvApiUrls.API_KEY_AWS
        }
      },
      baseUrl: EnvApiUrls.MAIN.replace('api/v1', ''),
      secondaryBaseUrl: `${EnvApiUrls.API_URL_AWS}/`
    },
    {
      actions
    }
  ];
};

export default useCandidateDataSheetSchema;
